import PropTypes from 'prop-types';
import SelectField from './SelectField';
import { renderLanguageOptions } from '../services/renderOptions';
import getTargetAttribute from '../services/getTargetAttribute';

const propTypes = {
    label: PropTypes.string,
    /**
     * Language map holding language keys and labels
     *
     * @example { en: 'English', es: 'Spanish', de: 'German' }
     */
    languages: PropTypes.shape({}),
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
};

const LanguageField = ({ label, languages, onChange, value }) => {
    const options = renderLanguageOptions(languages);

    return (
        <SelectField
            onChange={onChange}
            label={label}
            value={value}
            data-target={getTargetAttribute('language-field')}
        >
            {options}
        </SelectField>
    );
};

LanguageField.propTypes = propTypes;

export default LanguageField;
